export const MARKET_REQUEST_BID_FRAGMENT = `
fragment marketRequestBidFragment on MarketRequestBid {
  id
  quantity
  price
  isInterestedIndicator
  userId
}
`;
